import styled from 'styled-components';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const HeaderEntityValue = styled.div<{ valueStyle?: 'small' }>`
  display: inline-block;
  font-weight: 500;
  padding-right: 10px;
  min-height: ${(props) => (props.valueStyle === 'small' ? '18px' : '22px')};
  font-size: ${(props) => (props.valueStyle === 'small' ? '18px' : '22px')};
  color: ${p4Tokens.fieldLabel};
  white-space: nowrap;
`;
export default HeaderEntityValue;
